import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  tabPanel: {
    display: 'flex',
    width: '100%',
  },
  '@media (max-width: 1100px)': {
    tabPanel: {
      flexWrap: 'wrap',
    },
  },
}));

const TabPanel = ({ children, value, currentVal, index, className, ...other }) => {
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== currentVal}
      id={`tabpanel-${currentVal}`}
      aria-labelledby={`tab-${currentVal}`}
      className={className}
      {...other}
    >
      {value === currentVal && <div className={classes.tabPanel}> {children} </div>}
    </div>
  );
};

export default TabPanel;
